var map = {
	"./1.jpg": "46d6",
	"./2.jpg": "eafb",
	"./3.jpg": "9fc5",
	"./4.jpg": "cd5e",
	"./5.jpg": "fcec",
	"./6.jpg": "e70c",
	"./7.jpg": "e0b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c973";